import clsx from 'clsx';
import { FieldError } from 'react-hook-form';

export interface FieldWrapperProps {
  children: React.ReactNode;
  label?: React.ReactNode;
  labelSize?: 'xs' | 's' | 'm' | 'l' | 'xl';
  error?: FieldError;
  required?: boolean;
  className?: string;
  showError?: boolean;
}

export function FieldWrapper({ children, label, error, showError = true, labelSize, required }: FieldWrapperProps) {
  return (
    <div className="form-group">
      {label && (
        <label
          className={clsx('form-label', {
            'fs-9': labelSize === 'xs',
            'fs-8': labelSize === 's',
            'fs-7': labelSize === 'm',
            'fs-6': labelSize === 'l',
            'fs-5': labelSize === 'xl',
            required: required
          })}
        >
          {label}
        </label>
      )}
      {children}
      {error && showError && (
        <div className="fv-plugins-message-container">
          <div className="fv-help-block">{error.message}</div>
        </div>
      )}
    </div>
  );
}

export default FieldWrapper;
